import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SpaceShuttle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M130 480c40.6 0 80.4-11 115.2-31.9L352 384H128v96h2zm222-352L245.2 63.9C210.4 43 170.6 32 130 32h-2v96h224zm-256 0V32H80c-26.5 0-48 21.5-48 48v48h8c-22.1 0-40 17.9-40 40v176c0 22.1 17.9 40 40 40h-8v48c0 26.5 21.5 48 48 48h16v-96h8c26.2 0 49.4-12.6 64-32h288c69.3 0 135-22.7 179.2-81.6 6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32h-8zm416 115.6v24.9c0 19.6-15.9 35.6-35.6 35.6-2.5 0-4.4-2-4.4-4.4v-87.3c0-2.5 2-4.4 4.4-4.4 19.6 0 35.6 15.9 35.6 35.6z"
  }));
});
SpaceShuttle.displayName = 'SpaceShuttle';
export var SpaceShuttleDimensions = {
  height: 512,
  width: 640
};